<!-- 批量导入弹框 -->
<template>
<el-dialog
  :visible.sync="dialogVisible"
  width="30%" center>
  <div class="title">
    <span class="p1">批量导入</span>
    <span class="p2">下载文件模板</span>
  </div>
  <el-upload style="margin-bottom: 0.3rem;"
  class="upload-demo"
  action="https://jsonplaceholder.typicode.com/posts/"
  multiple
  :limit="3"
  :file-list="fileList">
  <span style="font-size: 0.12rem;">点击上传文件</span> <i style="color:#000" class="el-icon-upload"></i>
</el-upload>
<div>
    <el-tag size="small" closable>小型标签</el-tag>
</div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">导 入</el-button>
  </span>
</el-dialog>

</template>

<script>

export default {
components: {},
data() {
return {
  dialogVisible: false,
    fileList:[]
}
},
computed: {},
watch: {},
methods: {
    init() {
        this.dialogVisible = true
    }
},
created() {

},
mounted() {

},
}
</script>
<style lang='scss' scoped>
    .title {
        display: flex;
        align-items: center;
        position: relative;
        margin-bottom: 0.3rem;
        .p1 {
            font-size: 0.16rem;
            color: #000;
            position: absolute;
            left: 0;
            font-weight: bold;
        }
        .p2 {
            color: #606266;
            font-size: 0.12rem;
            border-bottom: 1px solid #b4b2b2;
            margin: 0 auto;
        }
    }
</style>